/* =====================================================================
   mmo457 · Verhalten der Hero-Optionen (27.08.2026)
   A „Wortwechsel": das letzte Wort der Überschrift wechselt alle 2,6 s weich.
   C „Schriftzug": die Überschrift füllt sich beim Scrollen — der Fortschritt
   (--mmo-p, 0–1) hängt an der Scrollposition, leicht geglättet.
   Option B ist rein statisch und braucht kein Skript.

   Wichtig: Horizon scrollt im Container .page-wrapper, nicht im Fenster.
   Der Scroll-Lauscher hängt deshalb mit capture am Dokument — das fängt
   jeden Scroller, auch wenn sich der Container einmal ändern sollte.
   ===================================================================== */
(function () {
  'use strict';

  // Die Sections können die Datei mehrfach einbinden (Theme-Editor) — nur einmal laufen
  if (window.__mmoHeroes) return;
  window.__mmoHeroes = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- A: Wortwechsel ---------- */
  // Wort und Modellbild wechseln im selben Takt: Index i schaltet in beiden Listen.
  // Inaktive Bilder sind Links — sie bekommen tabindex -1 und aria-hidden, damit
  // Tastatur und Vorleser immer nur das sichtbare Paar erreichen.
  function initWortwechsel(root) {
    if (root.dataset.mmoInit === '1') return;
    root.dataset.mmoInit = '1';
    var worte = root.querySelectorAll('[data-mmo-wort]');
    var bilder = root.querySelectorAll('[data-mmo-bild]');
    // Bei abgeschalteter Bewegung bleibt das erste Paar stehen (kommt aktiv aus dem Liquid)
    if (reduceMotion || worte.length < 2) return;

    function schalte(liste, i, an) {
      if (i >= liste.length) return;
      var el = liste[i];
      el.classList.toggle('is-aktiv', an);
      if (el.tagName === 'A') {
        el.tabIndex = an ? 0 : -1;
        el.setAttribute('aria-hidden', an ? 'false' : 'true');
      }
    }

    var i = 0;
    var timer = setInterval(function () {
      if (!root.isConnected) { clearInterval(timer); return; }
      schalte(worte, i, false);
      schalte(bilder, i, false);
      i = (i + 1) % worte.length;
      schalte(worte, i, true);
      schalte(bilder, i, true);
    }, 2600);
  }

  /* ---------- C: Schriftzug ---------- */
  function initSchrift(root) {
    if (root.dataset.mmoInit === '1') return;
    root.dataset.mmoInit = '1';
    // Bei abgeschalteter Bewegung übernimmt das CSS: gefüllt, normale Höhe
    if (reduceMotion) return;

    var stage = root.querySelector('.mmo-schrift__stage');
    var SMOOTH = 0.25; // Nachlauf der Glättung: kleiner = träger, 1 = ungefiltert
    var current = -1;
    var raf = null;

    // Fortschritt = durchscrollte Strecke geteilt durch die überschüssige Höhe
    function ziel() {
      var r = root.getBoundingClientRect();
      var span = r.height - (stage ? stage.getBoundingClientRect().height : 0);
      if (span <= 0) return 1;
      return Math.min(1, Math.max(0, -r.top / span));
    }

    function tick() {
      raf = null;
      if (!root.isConnected) return;
      var z = ziel();
      if (current < 0) current = z;
      current += (z - current) * SMOOTH;
      if (Math.abs(z - current) < 0.002) current = z;
      root.style.setProperty('--mmo-p', current.toFixed(3));
      // Weiterlaufen, bis die Glättung eingeschwungen ist
      if (current !== z) raf = requestAnimationFrame(tick);
    }

    function request() {
      if (!raf) raf = requestAnimationFrame(tick);
    }

    document.addEventListener('scroll', request, { capture: true, passive: true });
    window.addEventListener('resize', request, { passive: true });
    request();
  }

  /* ---------- Start ---------- */
  function setup(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-mmo-wortwechsel]').forEach(initWortwechsel);
    s.querySelectorAll('[data-mmo-schrift]').forEach(initSchrift);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); });
  } else {
    setup();
  }

  // Theme-Editor: Abschnitt neu geladen
  document.addEventListener('shopify:section:load', function (e) { setup(e.target); });
})();
